import * as React from "react";
import {useEffect, useState} from "react";
import {useSessionStorage} from "components/hooks/useSessionStorage";
import {useAddFavorite, useDeleteFavorite} from "features/authentication/services/FavoritesService/mutation";
import {useAuth} from "features/authentication/hooks/useAuth";
import {ResidenceCardData} from "features/search/types";
import {LoginType} from "features/authentication/enums";
import {useModal} from "features/modal/hooks/useModal";
import {LoginForm} from "components/forms/LoginForm";
import {getFormattedMessage} from "features/services/utils/language-helper";
import {PooledFavoriteKey} from "features/authentication/services/FavoritesService/config";
import {SignupParams} from "features/authentication/types.services";
import {useFavoriteStore} from "features/authentication/services/FavoritesService/useFavoriteStore";

export const useFavorite = (
    residence?: ResidenceCardData,
) => {
    const { open } = useModal();
    const {setValue: setPooledFavorite, removeValue: removePooledFavorite, storedValue: pooledFavorite} = useSessionStorage<SignupParams>(PooledFavoriteKey);
    const {mutate: addFavorite} = useAddFavorite();
    const {mutate: removeFavorite} = useDeleteFavorite();
    const {setShowFavoriteNotice} = useFavoriteStore();
    const {user, setLoginType} = useAuth();

    const [active, setActive] = useState<boolean>(false);

    useEffect(() => {
        if(!residence) return;

        const isActive = user?.favorites?.some(
            (x) => x.objectId === residence.id || x.stageId === residence.id
        ) || false;
        setActive(isActive);
    }, [user, residence]);

    const toggleFavorite = () => {
        if(!residence) return;

        const params = {
            objectId: residence.type === 'object' ? residence.id : undefined,
            stageId: residence.type === 'stage' ? residence.id : residence.stage,
        };

        if(!user) {
            setLoginType(LoginType.PRIVATE);

            open(
                <LoginForm
                    title={getFormattedMessage('jm.components.LoginForm.favoritesTitle')}
                    text={getFormattedMessage('jm.components.LoginForm.favoritesDescription')}
                    hideTypeToggle
                />,
                { fullscreen: false, closeCallback: () => removePooledFavorite(), ariaLabel: getFormattedMessage('jm.components.LoginForm.ariaLabel') }
            );

            setPooledFavorite(params);
            return;
        }

        if (active) {
            removeFavorite(params);
            setShowFavoriteNotice(false);

        } else {
            addFavorite(params);
            setShowFavoriteNotice(true);
        }

        setActive(!active);
    };


    return { active, toggleFavorite };
};
